import FormValue from "./FormValue";

export default class DataForm {

  constructor(data, asNew = false){
    this._data = data;
    this._newKeys = {};
    Object.keys(data).forEach(key => this[key] = new FormValue(data[key]));
    if(asNew){
      Object.keys(data).forEach(key => this._newKeys[key] = true);
    }
  }

  getModifiedKeys(){
    return Object.keys(this._data)
      .filter(k => this[k].modified || this._newKeys[k]);
  }

  getUpdateDto(){
    var obj = {};
    this.getModifiedKeys()
      .forEach(key => obj[key] = this[key].value);
    return obj;
  }

  getmodified(){
    return this.getModifiedKeys().length != 0;
  }

  reset(){
    this.getModifiedKeys()
      .forEach(key => this[key].reset());
  }

  get dto(){
    return this.getUpdateDto();
  }

}


// WEBPACK FOOTER //
// ./src/Editor/DataForm.js